"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Distance_exports = {};
__export(Distance_exports, {
  default: () => Distance_default
});
module.exports = __toCommonJS(Distance_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.8008 6.91016C14.3867 6.91016 14.9336 7.02083 15.4414 7.24219C15.9492 7.46354 16.3919 7.76953 16.7695 8.16016C17.1471 8.53776 17.4466 8.98047 17.668 9.48828C17.8893 10.0091 18 10.556 18 11.1289C18 11.5065 17.9219 11.9232 17.7656 12.3789C17.6094 12.8346 17.3685 13.3294 17.043 13.8633C16.7305 14.3971 16.3333 14.9701 15.8516 15.582C15.3698 16.194 14.8034 16.8516 14.1523 17.5547C14.1133 17.5938 14.0612 17.6263 13.9961 17.6523C13.931 17.6784 13.8659 17.6914 13.8008 17.6914C13.7487 17.6914 13.6901 17.6784 13.625 17.6523C13.5599 17.6263 13.5078 17.5938 13.4688 17.5547C12.8177 16.8516 12.2513 16.194 11.7695 15.582C11.2878 14.9701 10.8841 14.3971 10.5586 13.8633C10.2461 13.3294 10.0117 12.8346 9.85547 12.3789C9.69922 11.9232 9.62109 11.5065 9.62109 11.1289C9.62109 10.556 9.73177 10.0091 9.95312 9.48828C10.1745 8.98047 10.474 8.53776 10.8516 8.16016C11.2292 7.76953 11.6719 7.46354 12.1797 7.24219C12.6875 7.02083 13.2279 6.91016 13.8008 6.91016ZM13.7617 13.1602C14.3346 13.1602 14.8229 12.9583 15.2266 12.5547C15.6302 12.151 15.832 11.6628 15.832 11.0898C15.832 10.5039 15.6302 10.0091 15.2266 9.60547C14.8229 9.20182 14.3346 9 13.7617 9C13.1888 9 12.7005 9.20182 12.2969 9.60547C11.8932 10.0091 11.6914 10.5039 11.6914 11.0898C11.6914 11.6628 11.8932 12.151 12.2969 12.5547C12.7005 12.9583 13.1888 13.1602 13.7617 13.1602ZM6.26172 2.75C7.16016 2.75 7.92839 3.06901 8.56641 3.70703C9.20443 4.34505 9.52344 5.11979 9.52344 6.03125C9.52344 6.61719 9.28255 7.32682 8.80078 8.16016C8.31901 8.98047 7.58984 9.9375 6.61328 11.0312C6.5612 11.0833 6.5026 11.1224 6.4375 11.1484C6.38542 11.1745 6.32682 11.1875 6.26172 11.1875C6.19661 11.1875 6.13151 11.1745 6.06641 11.1484C6.0013 11.1224 5.94922 11.0833 5.91016 11.0312C4.93359 9.9375 4.20443 8.98047 3.72266 8.16016C3.24089 7.32682 3 6.61719 3 6.03125C3 5.11979 3.31901 4.34505 3.95703 3.70703C4.59505 3.06901 5.36328 2.75 6.26172 2.75ZM6.30078 7.75C6.52214 7.75 6.73047 7.71094 6.92578 7.63281C7.13411 7.54167 7.31641 7.41797 7.47266 7.26172C7.62891 7.10547 7.74609 6.92969 7.82422 6.73438C7.91536 6.52604 7.96094 6.3112 7.96094 6.08984C7.96094 5.62109 7.79818 5.22396 7.47266 4.89844C7.16016 4.57292 6.76953 4.41016 6.30078 4.41016C5.84505 4.41016 5.45443 4.57292 5.12891 4.89844C4.81641 5.22396 4.66016 5.62109 4.66016 6.08984C4.66016 6.54557 4.81641 6.9362 5.12891 7.26172C5.45443 7.58724 5.84505 7.75 6.30078 7.75ZM9.52344 17.75C8.8724 17.75 8.26693 17.6263 7.70703 17.3789C7.14714 17.1315 6.65234 16.7995 6.22266 16.3828C5.80599 15.9531 5.47396 15.4518 5.22656 14.8789C4.97917 14.319 4.85547 13.7135 4.85547 13.0625C4.85547 12.8021 4.94661 12.5807 5.12891 12.3984C5.3112 12.2161 5.53255 12.125 5.79297 12.125C6.05339 12.125 6.27474 12.2161 6.45703 12.3984C6.63932 12.5807 6.73047 12.8021 6.73047 13.0625C6.73047 13.8438 6.9974 14.5078 7.53125 15.0547C8.07812 15.6016 8.74219 15.875 9.52344 15.875C9.77083 15.875 9.98568 15.9661 10.168 16.1484C10.3503 16.3307 10.4414 16.5521 10.4414 16.8125C10.4414 17.0729 10.3503 17.2943 10.168 17.4766C9.98568 17.6589 9.77083 17.75 9.52344 17.75Z",
      fill: "currentColor"
    }
  )
);
const SvgDistance = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Distance_default = SvgDistance;
